var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-file"},[_c('div',{staticClass:"preview-file-imgs"},_vm._l((_vm.imgs),function(img){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(img),expression:"img"}],key:img})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }